/* eslint-disable import/prefer-default-export */
import React from 'react'
import { SvgIconProps } from './SvgIconProps'

export const Panel: React.FC<SvgIconProps> = ({ size = '24px', color = 'currentColor' }) => {
  return <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill={color}
      d="M3 4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4ZM5 5V19H9V5H5ZM11 5V19H19V5H11Z"
    />
  </svg>
}
